import React from 'react';
import styled from 'styled-components';
import { neutral600, white } from '@prezi/common-design';
import { Icons } from '../';
const Container = styled.div.withConfig({
  displayName: "TeamAvatar__Container",
  componentId: "sc-1f1cpik-0"
})(["width:30px;height:30px;background:", ";border-radius:50%;display:flex;justify-content:center;align-items:center;"], neutral600);
const TeamAvatar = () => React.createElement(Container, null, React.createElement(Icons.Users, {
  fill: white
}));
export default TeamAvatar;